import KeyLine from 'components/shared/KeyLine';
import { KeylineProps } from './types';

const Keyline = ({ testId }: KeylineProps) => {
  return (
    <div className="content-wrapper" data-testid={testId}>
      <KeyLine />
    </div>
  );
};

export default Keyline;
